// src/components/About.tsx

import { motion } from "framer-motion";

import { AiOutlineArrowRight } from "react-icons/ai";

import storyImage from "../assets/women.png";
import missionImage from "../assets/justmachine.png";
import visionImage from "../assets/Manusingmachine.png";

import "../styles/about.css";

const About = () => {

  return (

    <section
      id="about"
      className="about"
    >

      {/* =========================
          HEADER
      ========================= */}

      <div className="about-header">

        <span>
          ABOUT US
        </span>

        <h2>
          From Leaky Shakers
          <br />
          To Instant Fuel
        </h2>

        <p>

          Dagda helps busy gym members stay consistent
          by putting fresh workout nutrition inside the gym,
          not in their backpacks.

        </p>

      </div>

      {/* =========================
          STORY SECTION
      ========================= */}

      <div className="about-row">

        {/* IMAGE */}

        <motion.div
          className="about-image-wrapper"
          initial={{
            opacity:0,
            x:-40
          }}
          whileInView={{
            opacity:1,
            x:0
          }}
          transition={{
            duration:0.7
          }}
          viewport={{
            once:true
          }}
        >

          <div className="person-wrapper">

            <div className="orange-shape"></div>

            <div className="small-circle one"></div>

            <div className="small-circle two"></div>

            <img
              src={storyImage}
              alt="Dagda Story"
              className="person-image"
            />

          </div>

        </motion.div>

        {/* TEXT */}

        <motion.div
          className="about-content"
          initial={{
            opacity:0,
            x:40
          }}
          whileInView={{
            opacity:1,
            x:0
          }}
          transition={{
            duration:0.7
          }}
          viewport={{
            once:true
          }}
        >

          <span className="mini-tag">
            OUR STORY
          </span>

          <h3>
            Built Around
            Real Gym Life
          </h3>

          <p>

            We’re a small team in Ireland
            who live the same routine as you
            office, lectures, commute and then
            straight to the gym.

          </p>

          <p>

            We’ve experienced leaking shakers,
            forgotten protein tubs and the
            inconvenience of carrying supplements
            everywhere.

          </p>

          <p>

            So we built Dagda
            smart vending machines that deliver
            fresh protein and performance drinks
            instantly where people train.

          </p>

        </motion.div>

      </div>

      {/* =========================
          MISSION SECTION
      ========================= */}

      <div className="about-row reverse">

        {/* TEXT */}

        <motion.div
          className="about-content"
          initial={{
            opacity:0,
            x:-40
          }}
          whileInView={{
            opacity:1,
            x:0
          }}
          transition={{
            duration:0.7
          }}
          viewport={{
            once:true
          }}
        >

          <span className="mini-tag">
            OUR MISSION
          </span>

          <h3>
            Protein,
            Ready When You Are
          </h3>

          <p>

            Our mission is to deliver
            fresh, high-quality protein
            and performance drinks in
            under two minutes through
            intelligent vending technology.

          </p>

          <p>

            We help gym-goers stay consistent
            without carrying tubs, shakers
            or supplements from home.

          </p>

        </motion.div>

        {/* IMAGE */}

        <motion.div
          className="about-image-wrapper"
          initial={{
            opacity:0,
            x:40
          }}
          whileInView={{
            opacity:1,
            x:0
          }}
          transition={{
            duration:0.7
          }}
          viewport={{
            once:true
          }}
        >

          <div className="person-wrapper">

            <div className="orange-shape"></div>

            <div className="small-circle one"></div>

            <div className="small-circle two"></div>

            <img
              src={missionImage}
              alt="Dagda Mission"
              className="person-image_1"
            />

          </div>

        </motion.div>

      </div>

      {/* =========================
          VISION SECTION
      ========================= */}

      <div className="about-row">

        {/* IMAGE */}

        <motion.div
          className="about-image-wrapper"
          initial={{
            opacity:0,
            x:-40
          }}
          whileInView={{
            opacity:1,
            x:0
          }}
          transition={{
            duration:0.7
          }}
          viewport={{
            once:true
          }}
        >

          <div className="person-wrapper">

            <div className="orange-shape"></div>

            <div className="small-circle one"></div>

            <div className="small-circle two"></div>

            <img
              src={visionImage}
              alt="Dagda Vision"
              className="person-image"
            />

          </div>

        </motion.div>

        {/* TEXT */}

        <motion.div
          className="about-content"
          initial={{
            opacity:0,
            x:40
          }}
          whileInView={{
            opacity:1,
            x:0
          }}
          transition={{
            duration:0.7
          }}
          viewport={{
            once:true
          }}
        >

          <span className="mini-tag">
            OUR VISION
          </span>

          <h3>
            Smart Nutrition
            Everywhere
          </h3>

          {/* =========================
              VISION POINTS
          ========================= */}

          <div className="vision-points">

            <div className="vision-point">

              <div className="vision-arrow">

                <AiOutlineArrowRight size={18} />

              </div>

              <p>
                To make essential workout nutrition
                instantly available to every gym-goer.
              </p>

            </div>

            <div className="vision-point">

              <div className="vision-arrow">

                <AiOutlineArrowRight size={18} />

              </div>

              <p>
                Build the future of smart recovery
                experiences through automation
                and convenience.
              </p>

            </div>

          </div>

        </motion.div>

      </div>

    </section>
  );
};

export default About;